export default "__VITE_PUBLIC_ASSET__4ac460ed__"